module.exports = "<app-search-panel\n  [airports]=\"airports$ | async\"\n  (searchClicked)=\"handleSearchClick($event)\">\n</app-search-panel>\n"